export const dashboardWidgets = {
  upcoming: {
    title: "Prossimi arrivi",
    empty: "Nessun evento in programma",
    createBooking: "Crea prenotazione",
  },
  lastActivity: {
    title: "Attività recente",
  },
  portals: {
    title: "Canali di prenotazione sincronizzati",
    connectedSuccess: "Connesso con successo",
    unknownChannel: "Sconosciuto",
    connectNewChannel: "Connetti un nuovo canale",
    empty: "Non hai canali sincronizzati",
    connectChannel: "Connetti un canale",
    loadError: "Impossibile caricare i portali",
    errorTitle: "Errore",
  },
};
